'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.ageOn = ageOn;
exports.formatFinnishDate = formatFinnishDate;
exports.formatFinnishDateWithWeekday = formatFinnishDateWithWeekday;
exports.formatDateWithWeekday = formatDateWithWeekday;
exports.formatFinnishDatePretty = formatFinnishDatePretty;
exports.formatFinnishTwoDates = formatFinnishTwoDates;
exports.formatISODate = formatISODate;
exports.parseISODate = parseISODate;
exports.parseISODateWithLeadingZeros = parseISODateWithLeadingZeros;
exports.parseFinnishDate = parseFinnishDate;
exports.parseDate = parseDate;
exports.validateFinnishDate = validateFinnishDate;
exports.validateISODate = validateISODate;
exports.formatDateRange = formatDateRange;
exports.formatFinnishDateWithLeadingZeros = formatFinnishDateWithLeadingZeros;
exports.formatDateWithTimes = formatDateWithTimes;
exports.getParameter = getParameter;
exports.commaseparatedKeyValuesToObj = commaseparatedKeyValuesToObj;
exports.parseStringTrueFalseNumber = parseStringTrueFalseNumber;
exports.overrideObjValues = overrideObjValues;
exports.parseTime = parseTime;
exports.parseISOTime = parseISOTime;
exports.formatISOTime = formatISOTime;
var isoDateFormat = exports.isoDateFormat = 'YYYY-MM-DD';
var finnishDateFormat = exports.finnishDateFormat = 'DD.MM.YYYY';
var finnishDateFormatWithWeekday = exports.finnishDateFormatWithWeekday = 'dd DD.M.YYYY';
var finnishDateFormatPretty = exports.finnishDateFormatPretty = 'D.M.YYYY';
var finnishDateFormatWithWeekdayShort = exports.finnishDateFormatWithWeekdayShort = 'dd D.M.';
var isoTimeFormat = exports.isoTimeFormat = 'HH:mm';

function ageOn(date, dob) {
    var age = date.year() - dob.year();
    if (dob.month() > date.month() || dob.month() === date.month() && dob.date() > date.date()) {
        // Birthday is after target date.
        --age;
    }
    return age;
}

function formatFinnishDate(date) {
    return moment(date).format(finnishDateFormat);
}

function formatFinnishDateWithWeekday(date) {
    return moment(date).format(finnishDateFormatWithWeekday);
}

function formatDateWithWeekday(date, language) {
    moment.locale(language);
    return moment(date).format(finnishDateFormatWithWeekday);
}

function formatFinnishDatePretty(date) {
    return moment(date).format(finnishDateFormatPretty);
}

function formatFinnishTwoDates(daysStr, startDate, endDate, language) {
    var days = moment.duration(moment(endDate).diff(moment(startDate))).asDays();
    moment.locale(language);
    return days + daysStr + ', ' + moment(startDate).format(finnishDateFormatWithWeekdayShort) + ' - ' + moment(endDate).format(finnishDateFormatWithWeekdayShort);
}

function formatISODate(date) {
    if (date) {
        return moment(date).format(isoDateFormat);
    } else {
        return '';
    }
}

function parseISODate(dateString) {
    if (dateString) {
        var result = moment(dateString, moment.ISO_8601, /*strict=*/true);
        if (!result.isValid()) {
            return null;
        }
        return result.toDate();
    } else {
        return null;
    }
}

// 1.1.1900 -> 01.01.1900
function parseISODateWithLeadingZeros(dateString) {
    return parseISODate(dateString.replace(/(\b\d{1}\b)/, '0$1'));
}

function parseFinnishDate(dateString) {
    if (dateString) {
        var result = moment(dateString, 'D.M.YYYY', true);
        if (!result.isValid()) {
            return null;
        }
        return result.toDate();
    } else {
        return null;
    }
}

function parseDate(dateString) {
    return parseISODate(dateString) || parseFinnishDate(dateString);
}

function validateFinnishDate(dateString) {

    if (!dateString) {
        return false;
    }
    var parts = dateString.split('.');

    var day = parseInt(parts[0]);
    var month = parseInt(parts[1]);
    var year = parseInt(parts[2]);
    if (year < 1800 || year > 3000) {
        return false;
    }

    if ('' + day != parts[0] && ('0' + day != parts[0] || day > 9)) {
        return false;
    }
    if ('' + month != parts[1] && ('0' + month != parts[1] || month > 9)) {
        return false;
    }
    if ('' + year != parts[2]) {
        return false;
    }

    var isodate = year + '-' + (month < 10 ? '0' + month : '' + month) + '-' + (day < 10 ? '0' + day : '' + day);

    var date = new Date(isodate);
    return date.getDate() == day && date.getMonth() == month - 1 && date.getFullYear() == year;
}

function validateISODate(dateString) {

    if (!dateString) {
        return false;
    }
    var parts = dateString.split('-');

    var year = parseInt(parts[0]);
    var month = parseInt(parts[1]);
    var day = parseInt(parts[2]);
    if (year < 1800) {
        return false;
    }

    var isodate = year + '-' + (month < 10 ? '0' + month : '' + month) + '-' + (day < 10 ? '0' + day : '' + day);

    var date = new Date(isodate);
    return date.getDate() == day && date.getMonth() == month - 1 && date.getFullYear() == year;
}

// Returns date range in some of the following formats:
//
// 1.1.2019
//
// 1. - 5.1.2019
//
// 30.1. - 1.2.2019
//
// 31.12.2019 - 1.1.2020
function formatDateRange(beginDate, endDate, beginTime, endTime) {
    if (!beginDate || !endDate) {
        return null;
    }
    if (!(beginDate instanceof Date)) {
        beginDate = parseDate(beginDate);
    }
    if (!(endDate instanceof Date)) {
        endDate = parseDate(endDate);
    }

    if (beginTime && endTime) {
        return formatFinnishDatePretty(beginDate) + ' (' + beginTime + ') - ' + formatFinnishDatePretty(endDate) + ' (' + endTime + ')';
    }

    var endDateString = formatFinnishDatePretty(endDate);
    var result = '';
    if (beginDate.getDate() == endDate.getDate() && beginDate.getMonth() == endDate.getMonth() && beginDate.getFullYear() == endDate.getFullYear()) {
        return endDateString;
    }

    var beginDateString = beginDate.getDate() + '.';

    if (beginDate.getMonth() == endDate.getMonth() && beginDate.getFullYear() == endDate.getFullYear()) {
        return beginDateString + '-' + endDateString;
    }

    beginDateString += beginDate.getMonth() + 1 + '.';
    if (beginDate.getFullYear() == endDate.getFullYear()) {
        return beginDateString + '-' + endDateString;
    }

    beginDateString += beginDate.getFullYear();
    return beginDateString + ' - ' + endDateString;
}

// 1.1.1980
// -> 01.01.1980
function formatFinnishDateWithLeadingZeros(date) {
    if (!date) {
        return date;
    }

    var digits = [];
    var digits = date.split('.').map(function (digit) {
        if (digit.length === 1) {
            return '0' + digit;
        }
        return digit;
    });
    return digits.join('.');
}

// 1.1.2021 - 1.2.2021 (1:00-2:00)
function formatDateWithTimes(beginDate, beginTime, endTime) {
    return formatFinnishDatePretty(beginDate) + ' (' + beginTime + '-' + endTime + ')';
}

// Gets a query parameter from either normal query params or Angular query
// parameters (i.e. either before or after #)
function getParameter(name) {
    return _getParameterStr(name, location.hash) || _getParameterStr(name, location.search) || _getParameterStr(name, ' ' + _getParameterStrAfterQuestionMark(location.hash));
}

// #!test1/test2/?test3 <-- Get test3.
function _getParameterStrAfterQuestionMark(queryString) {
    return queryString.split('?')[1] ? queryString.split('?')[1] : '';
}

// Get parameter from query string (specified as a parameter). First character
// of query string is stripped (? or #).
function _getParameterStr(name, queryString) {
    // Not found in parameters following hash, search regular get
    // parameters.
    var items = queryString.substr(1).split('&');

    var result = null;
    for (var index = 0; index < items.length; index++) {
        var parts = items[index].split("=");
        if (parts[0] === name && parts.length > 1) {
            result = decodeURIComponent(parts[1]);
        } else if (parts[0] === name) {
            // Check if url contains parameter without =.
            result = true;
        }
    }
    return result;
}

// parse user manual input ex: "search: false, priceRange: false" to valid object.
// returns object
// NOTE: Only supports true/false values (does not quote the values!);
function commaseparatedKeyValuesToObj(string) {
    if (string.indexOf(":") === -1) {
        console.error("Should contain a ':' (colon): ", string);
    }
    var properties = string.split(',');
    var obj = {};
    properties.forEach(function (property) {
        var keyAndValue = property.split(':');
        var key = keyAndValue[0].trim();
        var parsedValue = parseStringTrueFalseNumber(keyAndValue[1]);
        obj[key] = parsedValue;
    });
    return obj;
}

function parseStringTrueFalseNumber(string) {
    // Convert string to true / false / number
    var output;
    string = string.trim();
    if (string === "true") {
        output = true;
    }
    if (string === "false") {
        output = false;
    }
    if (isNaN(string === false)) {
        output = Number(string);
    }
    return output;
}

function overrideObjValues(defaultObj, OverideObj) {
    if ((typeof defaultObj === 'undefined' ? 'undefined' : _typeof(defaultObj)) != 'object') {
        console.error("Should be object: ", defaultObj);
    }
    if ((typeof OverideObj === 'undefined' ? 'undefined' : _typeof(OverideObj)) != 'object') {
        console.error("Should be object: ", OverideObj);
    }
    for (var key in defaultObj) {
        console.log("OverideObj[key]: ", OverideObj[key]);
        if (OverideObj[key] != undefined) {
            defaultObj[key] = OverideObj[key];
        }
    }
    return defaultObj;
}

function parseTime(timeString) {
    return parseISOTime(timeString);
}

function parseISOTime(timeString) {
    if (timeString) {
        var result = moment(timeString, isoTimeFormat, /*strict=*/true);
        if (!result.isValid()) {
            return null;
        }
        return result.toDate();
    } else {
        return null;
    }
}

function formatISOTime(time) {
    if (time) {
        return moment(time).format(isoTimeFormat);
    } else {
        return '';
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/core/utils.js
// module id = 40
// module chunks = 0 2